export default __webpack_public_path__ + "static/media/profile-sq.95e9512e.jpg";